<section fxLayout="column" fxLayoutGap="16px">
  <bb-employment-type></bb-employment-type>
  <bb-loan-request></bb-loan-request>
</section>
